import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Adresses } from '../../shared/components/modal-view-location/components/list-addresses/interfaces/addresses-user.interface';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SelectedAddressService {
  private readonly SELECTED_ADDRESS_KEY = 'selected_address';
  private selectedAddressSubject = new BehaviorSubject<Adresses | null>(null);
  private isBrowser: boolean;
  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
    // Try to load selected address from localStorage on service initialization
    this.loadSelectedAddressFromStorage();
  }

  private loadSelectedAddressFromStorage(): void {
    if (!this.isBrowser) return;
    const storedAddress = localStorage.getItem(this.SELECTED_ADDRESS_KEY);
    if (storedAddress) {
      try {
        const address = JSON.parse(storedAddress) as Adresses;
        this.selectedAddressSubject.next(address);
      } catch (error) {
        console.error('Error parsing stored address:', error);
        localStorage.removeItem(this.SELECTED_ADDRESS_KEY);
      }
    }
  }

  setSelectedAddress(address: Adresses): void {
    if (!this.isBrowser) return;
    // Store in memory
    this.selectedAddressSubject.next(address);

    // Persist to localStorage
    localStorage.setItem(this.SELECTED_ADDRESS_KEY, JSON.stringify(address));
  }

  getSelectedAddress(): Observable<Adresses | null> {
    return this.selectedAddressSubject.asObservable();
  }

  getCurrentSelectedAddress(): Adresses | null {
    return this.selectedAddressSubject.value;
  }

  clearSelectedAddress(): void {
    if (!this.isBrowser) return;
    this.selectedAddressSubject.next(null);
    localStorage.removeItem(this.SELECTED_ADDRESS_KEY);
  }
}